<div echarts [options]="chartOptions()" (chartClick)="onChartClick($event)" class="strip-plot-chart"></div>
